import DropdownColumn from './DropdownColumn';
import OverlayButton from './OverlayButton';

DropdownColumn.Button = OverlayButton;

export default DropdownColumn;
